import { axios } from '@/plugins/axios';
import { TokenService } from '@/services/token';
import { AuthService } from '@/services/auth';

const tokenService = new TokenService();

function createRequestInterceptor(store: any) {
  axios.interceptors.request.use(function(config) {
    if (
      config.url?.match('token-refresh') == undefined &&
      localStorage.getItem('user') != null
    ) {
      const needsRefresh = tokenService.needsRefresh(
        JSON.parse(localStorage.getItem('user')!).exp
      );

      if (needsRefresh) {
        const authService = new AuthService();
        authService.refreshToken(localStorage.getItem('access__token')!);
      }
    }
    return config;
  });
}

function createResponseInterceptor(store: any) {
  axios.interceptors.response.use(
    function(response) {
      // Do something with response
      return response;
    },
    function(error) {
      // console.log(error.response);
      // store.commit('error/SET_ERROR', error);
      const {
        status,
        data,
        config: { url }
      } = error.response;
      console.log(status, data, url);

      if (status === 403) {
        // store.dispatch("notification/add", {
        //   type: "warning",
        //   message: "You need to have premium account."
        // });
      }
      if (status === 401) {
        // store.dispatch("notification/add", {
        //   type: "warning",
        //   message: "You need to have premium account."
        // });
        // store.dispatch('auth/logout');
      }
      if (status !== 401) {
        return Promise.reject(error);
      }
      try {
        // store.dispatch("auth/refreshToken");
        return Promise.reject(error);
      } catch (e) {
        // console.error(e);
      }
      return Promise.reject(error);
    }
  );
}

const plugin = (store: any) => {
  createRequestInterceptor(store);
  createResponseInterceptor(store);
};

export default plugin;
